import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_SETTING_REQUEST = "GET_SETTING_REQUEST";
export const GET_SETTING_SUCCESS = "GET_SETTING_SUCCESS";
export const GET_SETTING_ERROR = "GET_SETTING_ERROR";

//* ACTIONS ------------------------------------------------
export const getSettingRequest = (payload = {}, callback) => ({
  type: GET_SETTING_REQUEST,
  payload,
  callback,
});

export const getSettingSuccess = (data) => ({
  type: GET_SETTING_SUCCESS,
  payload: data,
});

export const getSettingError = (error) => ({
  type: GET_SETTING_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getSettingServiceRequest = async (id) => {
  const options = await withToken({
    method: Methods.GET,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(`/settings/${id}`, options);
};
